module.exports = __webpack_public_path__ + "ad0516fbc85c7cf2ace6d47d1d1834e1.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../images/speakers/small/kate-compton.jpg
// module id = 668
// module chunks = 0